import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
} from '../../core/overlay/overlay-directives';
import { ButtonComponent } from '../button/components/button/button.component';
import { ButtonDropdownIndicatorDirective } from '../button/directives/button-dropdown/button-dropdown-indicator.directive';
import { DropdownItemComponent } from '../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent, DropdownWidth } from '../dropdown/dropdown.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-results-limit-button',
  templateUrl: './results-limit-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonComponent,
    ButtonDropdownIndicatorDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    IconColorDirective,
    IconComponent,
    NgFor,
    OverlayOriginDirective,
    TranslatePipe,
  ],
})
export class ResultsLimitButtonComponent {
  @Input() public limit: number;
  @Input() public limitOptions: number[] = [15, 30, 60, 90, 200];
  @Output() public limitChange: EventEmitter<number> = new EventEmitter();

  public DropdownWidth = DropdownWidth;

  public trackByOptionValue(index: number, option: number): number {
    return option;
  }
}
